import { type ObjectValuesUnionType } from '../../../utils/typing';

export const KLBasketErrorCodes = {
  E_OP_NOT_RUNNING: 46000 /* => Le pari n'est pas éligible à Koh-Lanta car l'opération n'est pas en cours */,
  E_USER_NOT_IN: 46001 /* => Le pari n'est pas éligible à Koh-Lanta car tu n'as pas commencé l'aventure ou tu es éliminé */,

  E_BET_QUALIFY_FORBIDDEN: 46002 /* => Le pari n'est pas éligible à Koh-Lanta car le pari "Qualification" est interdit */,
  E_FREEBET_FORBIDDEN: 46003 /* => Le pari n'est pas éligible à Koh-Lanta car les Freebets sont interdits */,
  E_SYSTEM_FORBIDDEN: 46004 /* => Le pari n'est pas éligible à Koh-Lanta car les paris système sont interdits */,

  E_MATCH_PENDING: 46005 /* => Le pari n'est pas éligible à Koh-Lanta car ce match est déjà présent dans un pari en cours Koh-Lanta */,
  E_BADGE_PENDING: 46006 /* => Le pari n'est pas éligible à Koh-Lanta car un pari est déjà en cours sur ce badge */,
  E_BADGE_WON: 46008 /* => Le pari n'est pas éligible à Koh-Lanta car le badge est déjà gagné */,
  E_TOO_MANY_TRIES: 46012 /* => Le pari n'est pas éligible à Koh-Lanta car toutes les tentatives possibles sont déjà placées pour cette phase */,
  E_MATCH_PENDING_ORIENTATION: 46013 /* Le pari n’est pas éligible à Koh-Lanta car 3 paris ont déjà été placés sur la zone en cours */,

  E_START_DATE_OVER_48: 46007 /* => Le pari n'est pas éligible à Koh-Lanta car le match débute dans plus de 48h */,
  E_START_DATE_OVER_OPE: 46011 /* => Le pari n'est pas éligible à Koh-Lanta car le match débute après la fin de l'opération */,
  E_BETSLIP_NOT_ELIGIBLE: 46009 /* => Le pari n'est pas éligible à Koh-Lanta */,
  E_INTERNAL_ERROR: 46010 /* => Erreur interne Koh-lanta */,
};
export type KLBasketErrorCode = ObjectValuesUnionType<typeof KLBasketErrorCodes>;
